const API_BASE_URL = import.meta.env.VITE_API_URL;

if (!API_BASE_URL) {
    console.error('VITE_API_URL environment variable is not set');
}

export const API_URLS = {
    BASE: API_BASE_URL,
    TTS: `${API_BASE_URL}/decomp/tts`,
    EVALUATE: `${API_BASE_URL}/decomp/evaluate`,
    MANAGER: `${API_BASE_URL}/manager`,
}; 